import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorToolsTextSizeService {

  private showFontOptionsListener = new Subject<any>();
  private hideFontOptionsListener = new Subject<any>();
  private fontSizePlusListener = new Subject<any>();
  private fontSizeMinusListener = new Subject<any>();

  constructor() { }

  public listenShowFontOptions() {
    return this.showFontOptionsListener.asObservable();
  }

  public listenHideFontOptions() {
    return this.hideFontOptionsListener.asObservable();
  }
  public listenFontSizePlus() {
    return this.fontSizePlusListener.asObservable();
  }
  public listenFontSizeMinus() {
    return this.fontSizeMinusListener.asObservable();
  }

  public showFontSizeOptions() {
    this.showFontOptionsListener.next();
  }

  public hideFontSizeOptions() {
    this.hideFontOptionsListener.next();
  }

  public fontSizePlus() {
    this.fontSizePlusListener.next();
  }

  public fontSizeMinus() {
    this.fontSizeMinusListener.next();
  }

}
